module.exports = __webpack_public_path__ + "static/tools-ee49a09aa0ed4455afa840bb0841749e.png";